import axios from 'axios';

const BLOG_BASE = process.env.REACT_APP_BLOG_API || 'http://localhost:8081/api';

const blogApi = axios.create({ baseURL: BLOG_BASE });

// Attach JWT for admin calls
blogApi.interceptors.request.use(config => {
  const token = localStorage.getItem('adminToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Public
export const getPosts       = (page = 0, size = 9) => blogApi.get(`/posts?page=${page}&size=${size}`);
export const getPostById    = (id) => blogApi.get(`/posts/${id}`);
export const getPostBySlug  = (slug) => blogApi.get(`/posts/slug/${slug}`);

// Admin
export const login           = (credentials) => blogApi.post('/auth/login', credentials);
export const createPost      = (formData) => blogApi.post('/posts', formData, { headers: { 'Content-Type': 'multipart/form-data' }});
export const updatePost      = (id, formData) => blogApi.put(`/posts/${id}`, formData, { headers: { 'Content-Type': 'multipart/form-data' }});
export const deletePost      = (id) => blogApi.delete(`/posts/${id}`);
export const getAllPostsAdmin = () => blogApi.get('/posts/admin/all');
export const getPostAdmin    = (id) => blogApi.get(`/posts/admin/${id}`);

export default blogApi;
